import React, { Component } from 'react';
import InnerHeaderBar from '../../../shared/InnerHeaderBar/InnerHeaderBar';
import './ProjectChallenges.css';
import { Link } from 'react-router-dom';
import { Redirect, withRouter } from 'react-router-dom';
import { toolMenu } from '../../../config/toolMenu';
import * as _ from 'lodash';

class ProjectChallenges extends Component {
    constructor(props) {
        super(props);
        this.defaultParams = {};
        this.state = {
            toolkitValidationType: null,
        };
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.toolkitValidationType && nextProps.toolkitDataChanged && !this.state.toolkitValidationType) {
            this.setState({ toolkitValidationType: nextProps.toolkitValidationType })
        }
    }


    render() {
        if (this.props.toolkitDataChanged) {
            if(this.state.toolkitValidationType){
                return <Redirect to={{ pathname: `/${this.state.toolkitValidationType}/${this.props.projectId}` }} />
            }
        }
        let emptyToolName = null;
        let tools = toolMenu.map((item, key) => {
            let toolName = item.type;

            if(!emptyToolName &&  !this.props.projectData.validToolkits[toolName]) {
                emptyToolName = toolName
            }

            let completedTool = this.props.projectData.validToolkits[toolName];
            return (
                <div>
                    { item.parent ?
                        <div onClick={() => this.props.toolkitsValidation(this.props.projectData.projectId, item.parent, item.url)} className={ completedTool ? "completed-tool challenge-boxes" : ( emptyToolName === toolName ? "challenge-boxes empty-tool" : "challenge-boxes" )}>
                            { completedTool && <i className="fas fa-check"></i>}
                            <i className={item.icon} aria-hidden="true"></i>
                            <p> {item.name} </p>
                        </div>
                        :
                        <Link to={{ pathname: `/${item.url}/${this.props.projectData.projectId}` }} className={ completedTool ? "completed-tool challenge-boxes" : ( emptyToolName === toolName ? "challenge-boxes empty-tool" : "challenge-boxes" )}>
                            { completedTool && <i className="fas fa-check"></i>}
                            <i className={item.icon} aria-hidden="true"></i>
                            <p> {item.name} </p>
                        </Link>
                    }
                </div>
            )
        });

        return (
            <div className={this.props.projectChallengesToggle === this.props.projectData.projectId ? 'project-challenges box-opened' : 'project-challenges box-closed'}>
                <p className="shelf-title-p">Click the Tool You Wish To Access. When beginning a new plan, start with the Business Challenge tool.</p>
                <div className="icons-shelf">{tools}</div>

                {/* <div className="icons-shelf">
                    <Link to={{ pathname: `/challenge-statement/${this.props.projectData.projectId}` }} className="challenge-boxes">
                        <i className="fas fa-file" aria-hidden="true"></i>
                        <p> Challenge <br /> Statement </p>
                    </Link>
                    <Link to={{ pathname: `/influencer-map/${this.props.projectData.projectId}` }} className="challenge-boxes challenge-statement">
                        <i className="fas fa-compass" aria-hidden="true"></i>
                        <p> Influencer <br /> Map </p>
                    </Link>
                    <Link to={{ pathname: `/benefits-ladder/${this.props.projectData.projectId}` }} className="challenge-boxes">
                        <i className="fas fa-layer-group" aria-hidden="true"></i>
                        <p> Benefits <br /> Ladder </p>
                    </Link>
                    <div onClick={() => this.props.toolkitsValidation(this.props.projectData.projectId, 'benefitsLadder', 'Benefits Ladder', 'segmentation')} className="challenge-boxes challenge-statement">
                        <i className="fas fa-users" aria-hidden="true"></i>
                        <p> Needs-Based <br /> Segmentation </p>
                    </div>
                    <Link to={{ pathname: `/competitive-analysis/${this.props.projectData.projectId}` }} className="challenge-boxes">
                        <i className="fas fa-search" aria-hidden="true"></i>
                        <p> Competitive <br /> Analysis </p>
                    </Link>
                    <div onClick={() => this.props.toolkitsValidation(this.props.projectData.projectId, 'segmentation', 'Needs-Based Segmentation', 'segmentAttractiveness')} className="challenge-boxes challenge-statement">
                        <i className="fas fa-magnet" aria-hidden="true"></i>
                        <p> Segment <br /> Attractiveness </p>
                    </div>
                    <div onClick={() => this.props.toolkitsValidation(this.props.projectData.projectId, 'segmentation', 'Needs-Based Segmentation', 'abilityToCompete')} className="challenge-boxes challenge-statement">
                        <i className="fas fa-flag-checkered" aria-hidden="true"></i>
                        <p> Ability <br /> to Compete </p>
                    </div>
                    <div onClick={() => this.props.toolkitsValidation(this.props.projectData.projectId, 'compete', 'Ability to Compete', 'prioritizer')} className="challenge-boxes challenge-statement">
                        <i className="fas fa-crosshairs" aria-hidden="true"></i>
                        <p> The <br /> Prioritizer </p>
                    </div>

                    <div onClick={() => this.props.toolkitsValidation(this.props.projectData.projectId, 'compete', 'Ability to Compete', 'differential-advantage')} className="challenge-boxes challenge-statement">
                        <i className="fas fa-chart-line"></i>
                        <p> Differential <br/> Advantage</p>
                    </div>

                    <div onClick={() => this.props.toolkitsValidation(this.props.projectData.projectId, 'compete', 'Ability to Compete', 'positioning-statement')} className="challenge-boxes challenge-statement">
                        <i className="fas fa-pencil-alt" aria-hidden="true"></i>
                        <p> Positioning <br /> Statement </p>
                    </div>
                    <div onClick={() => this.props.toolkitsValidation(this.props.projectData.projectId, 'positioning', 'Positioning-Statement', 'value-proposition')} className="challenge-boxes challenge-statement" >
                        <i className="fas fa-tv" aria-hidden="true"></i>
                        <p> Value <br /> Proposition </p>
                    </div>
                    <div onClick={() => this.props.toolkitsValidation(this.props.projectData.projectId, 'valueProposition', 'Value-Proposition', 'pricing-value')} className="challenge-boxes challenge-statement">
                        <i className="fas fa-comments-dollar"></i>
                        <p> Pricing <br /> Perceived Value </p>
                    </div>
                </div> */}

            </div>
        )
    }
}

export default (ProjectChallenges);



// WEBPACK FOOTER //
// ./src/components/Toolkit/ProjectChallenges/ProjectChallenges.jsx